import SearchCustomerDisplay from './SearchCustomerDisplay'

export default SearchCustomerDisplay
